module.exports = __webpack_public_path__ + "img/step2.53d4d5af.png";